import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import jwt_decode from "jwt-decode";

const CaeAccessHome = () => {
  const { t } = useTranslation('common');
  const { token } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (token) {
      const decoded = jwt_decode(token);
      localStorage.setItem("token", token);
      navigate("/", { replace: true });
    }
  }, [token, navigate]);
  return <div>{t('status.loading')}</div>;
};

export default CaeAccessHome;
